export default "__VITE_ASSET__469a788c__"